import { render, staticRenderFns } from "./RiskIdentifyList.vue?vue&type=template&id=5e303b1e&scoped=true"
import script from "./RiskIdentifyList.vue?vue&type=script&lang=js"
export * from "./RiskIdentifyList.vue?vue&type=script&lang=js"
import style0 from "./RiskIdentifyList.vue?vue&type=style&index=0&id=5e303b1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e303b1e",
  null
  
)

export default component.exports